import styled from "styled-components"

import { Spinner } from "components/common/Spinner"

const WidgetLoader = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
`

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  margin: 20px 0 6px;
  text-align: center;
  padding: 0 5px;
  border-right: 1px solid var(--border-subtle);

  &:last-child {
    border-right: none;
  }

  h4 {
    font-size: 12px;
    color: var(--text-muted);
  }

  span {
    font-size: 24px;
    font-weight: 500;
    color: var(--text-primary);
  }
`

interface WidgetContentProps {
  isFetching: boolean
  data: { title: string; value: number | string }[]
  className?: string
}

const WidgetContent = ({ isFetching, data, className }: WidgetContentProps) => {
  return (
    <>
      {isFetching && (
        <WidgetLoader>
          <Spinner />
        </WidgetLoader>
      )}
      <Container className={className}>
        {data?.map(({ title, value }) => (
          <Item key={title}>
            <h4>{title}</h4>
            <span>{value}</span>
          </Item>
        ))}
      </Container>
    </>
  )
}

export default WidgetContent
